import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { useEffect } from 'react';
import { Helmet } from 'react-helmet';
import { useDispatch } from 'react-redux';
import { useLocation } from 'react-router';
import { addJsonLdArticle } from '@/actions/JsonLdActions';
import { CaseOneView } from '@/components/pages/case/CaseOneView';
import Layout from '@/container/Layout';
import RegistrationAlertModal from '@/container/Ui/Modal/RegistrationAlertModal';
import { APP_BASE_URL } from '@/define/env';
import { useUnmountRef } from '@/hooks/lifecycle/useUnmountRef';
import { usePopularList } from '@/hooks/pages/list/popular/usePopularList';
import { usePopularListColumnViewData, usePopularListProfessionalViewData, } from '@/hooks/pages/list/popular/usePopularListViewData';
import { useBoolState } from '@/hooks/state/useBoolState';
import { PROFFIT_DEFAULT_OGP } from '@/utils/constants/assets/s3';
import { REGISTRATION_TYPE_CASE_DETAIL } from '@/utils/resources/registration/registrationType';
import { caseOnePath, getAbsolutePath } from '@/utils/router/links';
/**
 * 案件事例紹介詳細ページ
 */
export const CaseOnePage = (props) => {
    var _a, _b, _c;
    const { caseOneData, isGuestUser, isProfessionalUser } = props;
    const { pathname } = useLocation();
    const url = getAbsolutePath(pathname);
    const dispatch = useDispatch();
    const unmountRef = useUnmountRef();
    const { isLoadingPopularCase, isLoadingPopularColumn, isLoadingPopularProfessional, popularCases, popularConsultantListHasMoreLink, popularProfessionals, populars, } = usePopularList({
        dispatch,
        isGuestUser,
        isProfessionalUser,
        unmountRef,
    });
    // 週間ランキング
    const weeklyRankingList = usePopularListColumnViewData({ populars });
    // 人気のコンサルタント
    const popularConsultantList = usePopularListProfessionalViewData({
        items: popularProfessionals,
    });
    // 会員登録モーダル
    const { boolState: isShowRegistrationModal, changeFalse: hideRegistrationModal, changeTrue: showRegistrationModal, } = useBoolState();
    // JSON-LD 追加
    useEffect(() => {
        var _a, _b, _c;
        const jsonLd = {
            author: [],
            datePublished: caseOneData.published_at,
            headline: caseOneData.title,
            image: [
                ((_b = (_a = caseOneData.category.thumbnail_picture) === null || _a === void 0 ? void 0 : _a.webp) === null || _b === void 0 ? void 0 : _b.src) ||
                    ((_c = caseOneData.category.thumbnail_picture) === null || _c === void 0 ? void 0 : _c.default.src),
            ],
            mainEntityOfPage: `${APP_BASE_URL}/${caseOnePath(`${caseOneData.id}`)}`,
        };
        dispatch(addJsonLdArticle(jsonLd));
    }, [caseOneData, dispatch]);
    return (_jsxs(Layout, Object.assign({ mainClassName: 'l-main case_common_container' }, { children: [_jsxs(Helmet, { children: [_jsx("title", { children: `事例紹介｜${caseOneData.title}｜PROFFIT` }), _jsx("meta", { content: `事例紹介｜${caseOneData.title}｜PROFFIT`, property: 'og:title' }), _jsx("meta", { content: 'article', property: 'og:type' }), _jsx("meta", { content: caseOneData.summary, property: 'og:description' }), _jsx("meta", { content: url, property: 'og:url' }), _jsx("meta", { content: 'PROFFIT', property: 'og:site_name' }), _jsx("meta", { content: ((_b = (_a = caseOneData.category.thumbnail_picture) === null || _a === void 0 ? void 0 : _a.webp) === null || _b === void 0 ? void 0 : _b.src) ||
                            ((_c = caseOneData.category.thumbnail_picture) === null || _c === void 0 ? void 0 : _c.default.src) ||
                            PROFFIT_DEFAULT_OGP, property: 'og:image' })] }), _jsx(CaseOneView, { caseOneData: caseOneData, isGuestUser: isGuestUser, isLoadingPopularCase: isLoadingPopularCase, isLoadingPopularConsultant: isLoadingPopularProfessional, isLoadingWeeklyRankingList: isLoadingPopularColumn, isProfessionalUser: isProfessionalUser, onClickRegistration: showRegistrationModal, popularCases: popularCases, popularConsultantList: popularConsultantList, popularConsultantListHasMoreLink: popularConsultantListHasMoreLink, weeklyRankingList: weeklyRankingList }), _jsx(RegistrationAlertModal, { isShow: isShowRegistrationModal, onClickOther: hideRegistrationModal, registrationType: REGISTRATION_TYPE_CASE_DETAIL })] })));
};
